import Vue from 'vue'
import Router from 'vue-router'

//期货
import kline from '../pages/futures/kline'
import dollar from '../pages/futures/dollar'
import transaction from '../pages/futures/transaction'


//首页
import index from '../pages/index'
import balance from '../pages/index/balance'
import gather from '../pages/index/gather'
import subAccount from '../pages/index/subAccount'
import kf from '../pages/index/kf'
import notice from '../pages/index/notice'
import noticeDetail from '../pages/index/noticeDetail'

// 排行榜
import sort from '../pages/sort'

//用户CRM
import crm from '../pages/crm'

//市场
import market from '../pages/market'
import buy from '../pages/market/buy'

//个人中心
import my from '../pages/my'
import share from '../pages/my/share'
import realName from '../pages/my/realName'
import paypwd from '../pages/my/paypwd'
import withdraw from '../pages/my/withdraw'
import withdrawRecord from '../pages/my/withdrawRecord'
import transfer from '../pages/my/transfer'
import transferRecord from '../pages/my/transferRecord'
import recharge from '../pages/my/recharge'
import rechargeRecord from '../pages/my/rechargeRecord'
import addSubAccount from '../pages/my/addSubAccount'
import publish from '../pages/my/publish'
import publishSellRecord from '../pages/my/publishSellRecord'
import publishBuyRecord from '../pages/my/publishBuyRecord'
import changePassWord from '../pages/my/changePassWord'
import feedbackFeedback from '../pages/my/feedbackFeedback'
import messageCenter from '../pages/my/messageCenter'
import transactionRecord from '../pages/my/transactionRecord'
import batchActiveAccount from '../pages/my/batchActiveAccount'
import levelQuery from '../pages/my/levelQuery'
import bill from '../pages/my/bill.vue'
import team from '../pages/my/team.vue'
import help from '../pages/index/help.vue'
import helpDetail from '../pages/index/helpDetail.vue'

//登录注册
import login from '../pages/user/login'
import register from '../pages/user/register'
import agreement from '../pages/user/agreement'
import findPassWord from '../pages/user/findPassWord'
import messageLogin from '../pages/user/messageLogin'
import emailLogin from '../pages/user/emailLogin'

//一键下单，托管
import keyOrder from '../pages/index/keyOrder.vue'
import keyOrderDown from '../pages/index/keyOrderDown'
import keyOrderEscrow from '../pages/index/keyOrderEscrow.vue'
import newAccount from '../pages/index/newAccount.vue'
import express from '../pages/index/express.vue'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: index
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/index/gather',
      name: 'gather',
      component: gather
    },
    {
      path: '/index/balance',
      name: 'balance',
      component: balance
    },
    {
      path: '/index/subAccount',
      name: 'subAccount',
      component: subAccount
    },
    {
      path: '/index/notice',
      name: 'notice',
      component: notice
    },
    {
      path: '/index/noticeDetail',
      name: 'noticeDetail',
      component: noticeDetail
    },
    {
      path: '/index/kf',
      name: 'kf',
      component: kf
    },
    {
      path: '/my/addSubAccount',
      name: 'addSubAccount',
      component: addSubAccount
    },
    {
      path: '/my/publish',
      name: 'publish',
      component: publish
    },
    {
      path: '/my/publishSellRecord',
      name: 'publishSellRecord',
      component: publishSellRecord
    },
    {
      path: '/my/publishBuyRecord',
      name: 'publishBuyRecord',
      component: publishBuyRecord
    },
    {
      path: '/my/levelQuery',
      name: 'levelQuery',
      component: levelQuery
    },
    {
      path: '/my/batchActiveAccount',
      name: 'batchActiveAccount',
      component: batchActiveAccount
    },
    {
      path: '/my/transactionRecord',
      name: 'transactionRecord',
      component: transactionRecord
    },
    {
      path: '/my/messageCenter',
      name: 'messageCenter',
      component: messageCenter
    },
    {
      path: '/my/changePassWord',
      name: 'changePassWord',
      component: changePassWord
    },
    {
      path: '/my/feedbackFeedback',
      name: 'feedbackFeedback',
      component: feedbackFeedback
    },
    {
      path: '/my/paypwd',
      name: 'paypwd',
      component: paypwd
    },
    {
      path: '/my/share',
      name: 'share',
      component: share
    },
    {
      path: '/my/realName',
      name: 'realName',
      component: realName
    },
    {
      path: '/my/recharge',
      name: 'recharge',
      component: recharge
    },
    {
      path: '/my/rechargeRecord',
      name: 'rechargeRecord',
      component: rechargeRecord
    },
    {
      path: '/my/withdraw',
      name: 'withdraw',
      component: withdraw
    },
    {
      path: '/my/withdrawRecord',
      name: 'withdrawRecord',
      component: withdrawRecord
    },
    {
      path: '/my/transfer',
      name: 'transfer',
      component: transfer
    },
    {
      path: '/my/transferRecord',
      name: 'transferRecord',
      component: transferRecord
    },
    {
      path: '/my/bill',
      name: 'bill',
      component: bill
    },
    {
      path: '/crm',
      name: 'crm',
      component: crm
    },
    {
      path: '/futures/dollar',
      name: 'dollar',
      component: dollar
    },
    {
      path: '/futures/kline',
      name: 'kline',
      component: kline
    },
    {
      path: '/futures/transaction',
      name: 'transaction',
      component: transaction
    },
    {
      path: '/market',
      name: 'market',
      component: market
    },
    {
      path: '/sort',
      name: 'sort',
      component: sort
    },
    {
      path: '/market/buy',
      name: 'buy',
      component: buy
    },
    {
      path: '/user/login',
      name: 'login',
      component: login
    },
    {
      path: '/user/findPassWord',
      name: 'findPassWord',
      component: findPassWord
    },
    {
      path: '/user/emailLogin',
      name: 'emailLogin',
      component: emailLogin
    },
    {
      path: '/user/messageLogin',
      name: 'messageLogin',
      component: messageLogin
    },
    {
      path: '/user/register/:pid',
      name: 'register',
      component: register
    },
    {
      path: '/user/agreement/:pid',
      name: 'agreement',
      component: agreement
    },
    {
      path: '/my',
      name: 'my',
      component: my
    },
    {
      path: '/my/team',
      name: 'team',
      component: team
    },
    {
      path: '/index/help',
      name: 'help',
      component: help
    },
    {
      path: '/index/helpDetail',
      name: 'helpDetail',
      component: helpDetail
    },
    {
      path: '/index/keyOrder',
      name: 'keyOrder',
      component: keyOrder
    },
    {
      path: '/index/keyOrderDown',
      name: 'keyOrderDown',
      component: keyOrderDown
    },
    {
      path: '/index/keyOrderEscrow',
      name: 'keyOrderEscrow',
      component: keyOrderEscrow
    },
    {
      path: '/index/newAccount',
      name: 'newAccount',
      component: newAccount
    },
    {
      path: '/index/express',
      name: 'express',
      component: express
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js